import { React, useState, useContext, useEffect, useRef } from 'react'
import Profile from '../../assets/images/profile-img.png';
import SubHeader from './SubHeader';
import { FaPlus, FaCamera, FaEdit } from "react-icons/fa";
import { Col, Row, FormGroup, Label, Input, Form,NavLink } from 'reactstrap';
import { GlobalContext } from '../../App';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import ModalDialog from '../global/ModalDialog';
import Button from '../global/Button';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function PersonalDetail() {
    // Special Access Edit Email And Phone Number
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const { rolexModuleData, user_id,roles,userProfile } = useContext(GlobalContext);
    const [profilePicOpen, setProfilePicOpen] = useState(false);
    const [userData, setUserData] = useState({
        name: null,
        emailId: null,
        contactNumber: null,
        bu: null,
        department: null,
        profileImageUrl: null,
        username:null,
        company:null
    })
    const [loading, setLoading] = useState(false); 
     // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
    // ------------------------------------------------------------------- Get User Profile --------------------------------------- 
    const getUserProfile = () => {
        setLoading(true);
        axios.post('/getUserProfile', { user_id }).then((response) => {
            const UserProfileData = {
                name: response?.data?.[0]?.user_data?.[0]?.name,
                emailId: response?.data?.[0]?.user_data?.[0]?.email_id,
                contactNumber: response?.data?.[0]?.user_data?.[0]?.contact_number,
                bu: response?.data?.[0]?.user_data?.[0]?.bu_master?.[0],
                department: response?.data?.[0]?.user_data?.[0]?.department_master?.[0],
                company: response?.data?.[0]?.user_data?.[0]?.company_master?.[0],
                profileImageUrl: response?.data?.[0]?.user_data?.[0]?.profile_image_url,
                username: response?.data?.[0]?.user_data?.[0]?.username,
                firstLoginStatus: response?.data?.[0]?.user_data?.[0]?.firstLoginStatus,
            };
            setUserData(UserProfileData);
            localStorage.setItem('userProfile', btoa(JSON.stringify(UserProfileData)));
            setLoading(false);
          }).catch(handleError);
      };
    // --------------------------------------------------------- Profile Image Setup ---------------------------------------
    const inputFile = useRef(null);
    const [upImg, setUpImg] = useState();
    const imgRef = useRef(null);
    const canvasRef = useRef(null);
    const [crop, setCrop] = useState({ unit: "%", width: 30, aspect: 1 / 1 });
    const croppedImage = useRef(null);
    
    const onSelectFile = (e) => {
      if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.addEventListener("load", () => setUpImg(reader.result));
        reader.readAsDataURL(e.target.files?.[0]);
      }
    };
    
    const onLoad = (img) => {
      imgRef.current = img;
    };
    
    const onButtonClick = () => {
      inputFile.current.click();
    };
    
    const onCropComplete = (crop) => {
      makeClientCrop(crop);
    };
    
    const makeClientCrop = (crop) => {
      if (imgRef.current && crop.width && crop.height) {
        getCroppedImg(imgRef.current, crop, "newFile.jpeg")
          .then((croppedImg) => {
            croppedImage.current = croppedImg;
          }).catch(handleError);
      }
    };
    
    const getCroppedImg = (image, crop, fileName) => {
      if (!canvasRef.current || !imgRef.current) {
        return Promise.reject("Canvas or image element not available.");
      }
    
      const canvas = canvasRef.current;
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext("2d");
      const pixelRatio = window.devicePixelRatio;
    
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;
    
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    
      return new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject("Failed to get the cropped image blob.");
              return;
            }
            blob.name = fileName;
            resolve(blob);
          },
          "image/jpeg"
        );
      });
    };
    
    const onSubmit = (e) => {
      e.preventDefault();
      let formData = new FormData();
      formData.append("profile_pic", croppedImage?.current, croppedImage?.current.name);
      formData.append("user_id", user_id);
      axios.post('/userProfilePic', formData).then(() => {
        toast.success("Profile is updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
        handleClose();
        localStorage?.removeItem('userProfile');
        getUserProfile();
        // window.location.reload();  // remove it before solution
      }).catch(handleError);
    };
    
    // -------------------------------------------------------- Handel Close ----------------------------------------
    const handleClose = () => {
        setProfilePicOpen(false);
        setUpImg(null);
        setCrop({ unit: "%", width: 30, aspect: 1 / 1 })
    };
    // ------------------------------------------------------- Add User --------------------------------------------
    const updateUserProfile = (e) => {
        e.preventDefault();
            if (userData?.name === null || userData?.name === "") {
                toast.error("Name is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (userData?.emailId === null || userData?.emailId === "") {
                toast.error("Email ID is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (userData?.contactNumber === null || userData?.contactNumber === "") {
                toast.error("Phone Number is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else {
                const params = {
                    userData: userData,
                    user_id: user_id
                }
                axios.post('/updateUserProfile', params).then((response) =>{
                    toast.success("User Profile is updated successfully!", {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                    localStorage?.removeItem('userProfile');
                    getUserProfile();
                }).catch(handleError);
            }
    }
    // ---------------------------------------------------------- Mantain Log History ------------------------------
const postLogHistory = () =>{
    const param = {
      user_id : user_id,
      module_name : 'Personal Settings',
      operationPerformed : 'navigate to personal details screen',
    }
    axios.post('/postLogHistory',param);
  }
    // -------------------------------------------------------- Use Effect -----------------------------------------
    useEffect(() => {     
      setUserData(userProfile);
        // postLogHistory();
    }, [])
    // ---------------------------------------------------------- HTML Start ----------------------------------------
    return (
        loading ? (
            <div className="loader">
            <InfinitySpin width="200" color="#D81159" />
          </div>
          ) :
       ( <>
         <TopHeader
      breadCrumb = {
            <>
                <li className="nav-item"><a onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
                <li className="nav-item"><span>Personal Settings</span></li>
            </>
            }
            userData={userData}
            />
            <SubHeader SubHeaderTitle="Personal Information" />
            <div className='personaldetail-wrap contentInnerWrap'>
                <div className='personalinfo'>
                    <div className='profileimage'>
                        {/* <img src={userData?.profileImageUrl?.length > 0 ? (global.SERVER_URL + '/userImg/' + userData?.profileImageUrl) : Profile} alt="User Profile Images" /> */}
                        <img src={userData?.profileImageUrl?.length > 0 ? (userData?.profileImageUrl) : Profile} alt="User Profile Images" />
                        {((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1))|| roles?.find((data) => data?.role_id === 1001) ) ? <NavLink onClick={() => setProfilePicOpen(true)}> <FaCamera /></NavLink> : null}
                    </div>
                    <div className='personaldetails'>
                        <Form onSubmit={updateUserProfile}>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="exampleaboutme"> Name * </Label>
                                        <Input id="exampleaboutme" name="text" type="text" value={userData?.name} onChange={(e) => setUserData({ ...userData, name: e.target.value })} disabled={((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1))|| roles?.find((data) => data?.role_id === 1001) ) ? false : true} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="exampleaboutme"> User ID * </Label>
                                        <Input id="exampleaboutme" name="text" type="text" value={userData?.username} disabled />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="exampleaboutme"> Email ID *</Label>
                                        <Input id="exampleaboutme" name="text" type="text" value={userData?.emailId} onChange={(e) => setUserData({ ...userData, emailId: e.target.value })} disabled={((rolexModuleData?.find((data) => pathname === data?.description && data?.special === 1))|| roles?.find((data) => data?.role_id === 1001) ) ? false : true} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="exampleaboutme"> Mobile Number * </Label>
                                        <Row>
                                            <div className="col-3">
                                                <Input id="exampleaboutme" name="text" type="text" value='+91 ' disabled />
                                            </div>
                                            <div className="col-9">
                                                <Input id="exampleaboutme" name="text" type="number" placeholder='+91 ' value={userData?.contactNumber} onChange={(e) =>{ const inputValue = e.target.value.replace(/\D/g, "").slice(0, 12); setUserData({ ...userData, contactNumber: inputValue });} } disabled={((rolexModuleData?.find((data) => pathname === data?.description && data?.special === 1))|| roles?.find((data) => data?.role_id === 1001)) ? false : true} />
                                            </div>
                                        </Row>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="company"> Company </Label>
                                        <Input id="company" name="text" type="text" value={userData?.company?.company_name}  disabled />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor="bu"> BU </Label>
                                        <Input id="bu" name="text" type="text" value={userData?.bu?.bu_name}  disabled />
                                    </FormGroup>
                                </Col>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label htmlFor="department"> Department </Label>
                                        <Input id="department" name="text" type="text" value={userData?.department?.department_name}  disabled />
                                    </FormGroup>
                                </Col>
                                {((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1))|| roles?.find((data) => data?.role_id === 1001)) ?   <Col md={6}>
                                    <FormGroup>
                                        <Button color="primary" className="btn" type="submit" style={{ borderRadius: '8px', marginRight: '8px', boxShadow: 'none', padding: '0' }} >
                                            Save
                                        </Button>
                                    </FormGroup>
                                </Col> : null}
                              
                            </Row>
                        </Form>
                    </div>

                </div>
            </div>
            <ModalDialog
                open={profilePicOpen}
                handleClose={handleClose}
                Header={{ Title: "Upload Profile Picture", Sub_Title: "Upload your profile picture here" }}
                className="popupheader "
                style={{ width: '480px' }}
                icon={<FaCamera />}
                content={
                    <Form name="personal-info-details" className='modelform' onSubmit={onSubmit}>
                        <div className=" text-center">
                            {
                                !upImg ? (
                                    (userData?.profileImageUrl) ? (
                                        < div className='upload-input'>
                                            <div className='profileimage'>
                                                <div className='cropimage'>
                                                    <img src={userData?.profileImageUrl?.length > 0 ? (userData?.profileImageUrl) : Profile} alt="User Profile Images" />
                                                </div>
                                            </div>
                                            <div>
                                                <input
                                                    accept=".png, .jpg, .jpeg"
                                                    id="profile-pic"
                                                    ref={inputFile}
                                                    onChange={onSelectFile}
                                                    name="image"
                                                    type="file"
                                                />
                                                <button type='button' className="btn-primary" onClick={() => { onButtonClick() }} >
                                                    <FaEdit />
                                                    Change Profile Picture
                                                </button>
                                            </div>
                                        </div>
                                    ) :
                                        (

                                            < div className='upload-input'>
                                                <input
                                                    accept=".png, .jpg, .jpeg"
                                                    id="profile-pic"
                                                    ref={inputFile}
                                                    onChange={onSelectFile}
                                                    name="image"
                                                    type="file"
                                                />

                                                <button type='button' className="btn-primary" onClick={() => { onButtonClick() }} >
                                                    <FaPlus />
                                                    Browse Image
                                                </button>
                                            </div>
                                        )
                                ) :
                                    (
                                        <div className='profileimage'>
                                            <div className='cropimage'>
                                                <canvas
                                                    ref={canvasRef}
                                                    className="profilePreview"
                                                />
                                            </div>
                                            <div className='uploadimage'>
                                                <ReactCrop
                                                    // style={{ maxWidth: "50%" }}
                                                    src={upImg}
                                                    onImageLoaded={onLoad}
                                                    crop={crop}
                                                    onChange={(c) => setCrop(c)}
                                                    onComplete={onCropComplete} />
                                            </div>
                                            <div className='button-wrap'>

                                                <div className="ButtonComponent">
                                                    {/* <button type="submit" className="btn m-auto btn-primary" /> */}
                                                    <button type="submit" className="btn m-auto btn-primary">Save</button>
                                                    <NavLink href='#' style={{ display: 'inline-block', marginLeft: '10px' }} className='cancelbutton' onClick={handleClose}>Cancel</NavLink>
                                                </div>
                                                {/* <Button className="mr-2 btn-primary" label="Cancel" onClick={handleClose5} /> */}
                                            </div>
                                        </div>
                                    )
                            }
                        </div>
                    </Form>
                } />
        </>)
    )
}

export default PersonalDetail